import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import LoadingSpinner from '../../components/LoadingSpinner'

export default function AuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    const handleCallback = async () => {
      const { data: { session } } = await supabase.auth.getSession()

      if (!session) {
        navigate('/login')
        return
      }

      // Check if supporter record exists
      const { data: supporter } = await supabase
        .from('supporters')
        .select('role')
        .eq('id', session.user.id)
        .maybeSingle()

      if (!supporter) {
        // New user — redirect to complete registration
        navigate('/register/complete')
        return
      }

      // Check for pending redirect saved before Google OAuth (e.g. from shop checkout)
      let redirectTo = null
      try {
        redirectTo = localStorage.getItem('mwfc_auth_redirect')
        if (redirectTo) localStorage.removeItem('mwfc_auth_redirect')
      } catch {}

      // Redirect based on role, respecting any saved redirect for supporters
      if (supporter.role === 'supporter') {
        navigate(redirectTo || '/dashboard')
      } else if (supporter.role === 'club_admin') {
        navigate('/admin')
      } else if (supporter.role === 'chapter_coordinator') {
        navigate('/coordinator')
      } else if (supporter.role === 'super_admin') {
        navigate('/superadmin')
      } else {
        navigate('/login')
      }
    }

    handleCallback()
  }, [navigate])

  return <LoadingSpinner fullScreen message="Completing sign in..." />
}